import {EventEmitter, EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import {AfterDayEvaluationEvent} from "@/modules/season/events/AfterDayEvaluationEvent";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import chance from "@/modules/base/services/chance";
import {AfterPlayerEnergyGainEvent} from "@/modules/team/events/AfterPlayerEnergyGainEvent";
import {BeforePlayerEnergyGainEvent} from "@/modules/team/events/BeforePlayerEnergyGainEvent";
import {BeforePlayerCreatedEvent} from "@/modules/team/events/BeforePlayerCreatedEvent";

@injectable()
export class PlayerEnergyEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(EventEmitter) private eventEmitter: EventEmitter,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterDayEvaluationEvent, callback: this.onAfterDayEvaluationEvent},
      {event: BeforePlayerCreatedEvent, callback: this.onBeforePlayerCreatedEvent},
    ];
  }

  async onBeforePlayerCreatedEvent(event: BeforePlayerCreatedEvent) {
    if (this.configRepository.get('debug') && event.player.team?.user) {
      event.player.energy = chance.integer({min: 1, max: 100});
      await event.player.save();
    }
  }

  async onAfterDayEvaluationEvent(event: AfterDayEvaluationEvent) {
    const players = await Player
      .createQueryBuilder('player')
      .leftJoin('player.team', 'team')
      .where('team.user = true AND player.energy < 100')
      .getMany();

    await players.forEachAsync(async (player: Player) => {
      const energyGain = this.configRepository.get('players.energy.dailyEnergyGain')(player);

      await this.eventEmitter.emitAsync(new BeforePlayerEnergyGainEvent(player, energyGain));

      player.energy = Math.min(100, player.energy + energyGain);
      await player.save();

      await this.eventEmitter.emitAsync(new AfterPlayerEnergyGainEvent(player, energyGain));
    });
  }
}